import React from 'react';
import Styled from 'styled';

import Image, { Props as ImageProps } from 'four-nets/photoblog/posts/common/feed-images/image/image';
import { FeedImagesFragment } from 'four-nets/photoblog/posts/common/feed-images/feed-images.graphql';

import defaultStyles from './vendor-showcase.scss';

export enum ShowcaseType {
    VENDOR = 'VENDOR',
    WEDDING = 'WEDDING',
}

interface Props extends Partial<FeedImagesFragment> {
    styles: typeof defaultStyles;
    imgRef: any;
    onClick: any;
    type?: ShowcaseType;
    maxImageCount: number;
}

const VendorStyledImage = (props: Omit<ImageProps, 'styles'>) => (
    <Image style={{ imageWrapper: defaultStyles.vendorStyledImage }} {...props} />
);
const WeddingStyledImage = (props: Omit<ImageProps, 'styles'>) => (
    <Image style={{ imageWrapper: defaultStyles.weddingStyledImage }} {...props} />
);

class Showcase extends React.PureComponent<Props> {
    static defaultProps = {
        type: ShowcaseType.VENDOR,
        maxImageCount: 8,
    };

    render() {
        const { styles, images, newImagesCount, imagesCount, imgRef, onClick, type, maxImageCount } = this.props;

        return (
            <ul className={styles.images}>
                {images &&
                    images.edges.slice(0, maxImageCount).map((edge, index) => {
                        const notLoaded = !(edge && edge.node);
                        if (notLoaded) {
                            return null;
                        }

                        return edge && edge.node && edge.node.photoFile ? (
                            <li key={(edge && edge.node && edge.node.id) || ''} className={styles.listImage}>
                                {imagesCount && index + 1 === maxImageCount && index + 1 < imagesCount ? (
                                    <div className={styles.moreImages}>
                                        <span className={styles.imageCount}>{`+${imagesCount - maxImageCount}`}</span>
                                    </div>
                                ) : null}
                                {type === ShowcaseType.WEDDING ? (
                                    <WeddingStyledImage
                                        key={edge.node.id}
                                        index={index}
                                        imgRef={imgRef}
                                        onClick={onClick}
                                        onlyChild={newImagesCount === 1 || imagesCount === 1}
                                        {...edge.node}
                                    />
                                ) : (
                                    <VendorStyledImage
                                        key={edge.node.id}
                                        index={index}
                                        imgRef={imgRef}
                                        onClick={onClick}
                                        onlyChild={newImagesCount === 1 || imagesCount === 1}
                                        {...edge.node}
                                    />
                                )}
                            </li>
                        ) : null;
                    })}
            </ul>
        );
    }
}

export default Styled(defaultStyles)(Showcase);
